<template>
  <div class="wrap">
    <!-- businessStatus 10：正常营业 11：企业停业 12：经营范围变更 -->
    <div class="top_title" v-if="emphasisData.businessStatus === 11">
        该企业现已停业,以下数据均为停业前数据
        <!-- {{ emphasisData.businessStatus }} -->
    </div>
    <div class="top_title" v-if="emphasisData.businessStatus === 12">
        该企业现处于经营范围变更状态,以下数据均为变更前数据
    </div>
    <div class="box_wrap">
    <div class="scoreTop" v-if="true">
      <div class="scoreTop_left">
        <div class="hotel">{{format.registerName}}</div>
        <div class="tag">
          <div class="adre line_border_btn_blue" v-if="format.regionName">{{format.regionName}}</div>
          <div class="touri line_border_btn" v-if="format.industryCategoryName">{{format.industryCategoryName}}</div>
        </div>
        <div class="timeAdress">营业时间:{{format.businessDate}}</div>
        <div class="timeAdress timeAdressItem">详细地址：{{format.address}}</div>
        <div class="more" @click="goCompany">更多企业详情<span>&gt;</span></div>
      </div>
      <div class="scoreTop_right line_left" :class="{warm_text: format.score<5}" v-if="format.score">
        <div class="score">{{format.score}}<span>分</span></div>
        <div class="scoreNo">诚信指数</div>
      </div>
      <div class="scoreTop_right line_left" v-else>
        <div class="score_wu">暂无</div>
        <div class="scoreNo">诚信指数</div>
      </div>
    </div>

    <div class="scoreChange" v-if="false">
         <p class="score1">大理漫湾大酒店有限公司名称名称</p>
         <div class="schange">
             <span>变更</span>
             <span>经营范围已变更</span>
         </div>
         <p class="score2">营业变更前：餐饮 | 8.75分</p>
         <p class="score2">变更时间：2017-02-08 ~ 2017-02-08</p>
    </div>
    <!-- 经验范围变更，详情入口 -->
    <div class="changeCom" v-if="false">
          <span class="tip1">变更</span>
          <span class="tip2">经营范围变更前：餐饮 | 8.75分</span>
          <div class="changeDetail">
              <span class="tip3">变更详情</span>
              <img src="../../../../assets/integrity/left.png"/>
          </div>
    </div>
    <div class="brackBox" v-show="emphasisData.statusName && emphasisData.status !== 40">
      <!-- 重点关注状态（20：进入重点关注，30:已提交退出申请（重点关注）,40：退出重点关注，50：纳入黑名单）  -->
      <div :class="emphasisData.statusName !=='黑名单'?'brackBox_header':'brackBox_header_wrap'">
        <div class="header_left">
          <img src="../../../../assets/integrity/ic_hmd@3x.png" alt="" v-if="emphasisData.statusName ==='黑名单' || emphasisData.statusName ==='停业前被纳入黑名单'  || emphasisData.statusName ==='变更前被纳入黑名单'">
          <img src="../../../../assets/integrity/ic_zdjg@3x.png" alt="" v-else >
          <div>{{emphasisData.statusName}}</div>
        </div>
        <div class="header_right"  @click="goSupervisionDetails">
          <div>监管详情</div>
          <div>
            <img  src="../../../../assets/integrity/left.png" alt="" style="width:12px;height:12px;">
          </div>
        </div>
      </div>
      <div class="center" v-if="emphasisData.enteredScore !== undefined">
        <div class="score_title">
            <div class="left">纳入评分</div>
            <div class="right">{{emphasisData.enteredScore.score|toFix()}}</div>
        </div>
        <div class="score_count">
            <div class="count_box">
                <span class="count_box_left">规范指数：</span>
                <span class="count_box_right">{{emphasisData.enteredScore.standardScore}}</span>
            </div>
            <div class="count_box">
                <span class="count_box_left">品质指数：</span>
                <span class="count_box_right">{{emphasisData.enteredScore.qualityScore}}</span>
            </div>
            <div class="count_box">
                <span class="count_box_left">体验指数：</span>
                <span class="count_box_right">{{emphasisData.enteredScore.experienceScore}}</span>
            </div>
        </div>
      </div>
      <div class="brackBox_time line_top">
        <div class="time_top">
          <span>{{ emphasisData.statusName == '停业前被纳入重点关注' ? '进入重点关注时间：' : emphasisData.statusName == '停业前被纳入黑名单' ? '进入黑名单时间：' : '纳入时间：' }}</span>
          <span v-if="emphasisData.time">{{emphasisData.enteredTime|filt()}}</span>
        </div>
        <div>
          <!-- <span>已进入：</span> -->
          <span v-if="emphasisData.diffDay">{{emphasisData.diffDay}}</span>
        </div>
        <div class="brackType" v-if="emphasisData.status === 30">已提交退出申请</div>
      </div>
    </div>
    <div class="brackBoxEdit" v-if="emphasisData.status === 40">
      <div class="brackBox_header">
        <div class="header_left">
          <div>{{'已退出重点关注'}}</div>
        </div>
        <div class="header_right"  @click="goSupervisionDetails">
          <div>监管历史</div>
          <div>
            <img  src="../../../../assets/integrity/left.png" alt="" style="width:12px;height:12px;">
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="keySupervisionBox" v-show="emphasisData.statusName">
      <div class="keySupervisionContent">
        <img v-if="emphasisData.statusName=='黑名单'"  src="../../../../assets/integrity/ic_hmd@3x.png" alt="">
        <img v-else src="../../../../assets/integrity/ic_zdjg@3x.png" alt="">

        <div class="left_box">
            <div class="keySupervisionTop">
              <div class="stateTitle">{{emphasisData.statusName}}</div>
              <div class="toDetail" @click="goSupervisionDetails">
                <span>{{statusTypeName}}</span>
                <img src="../../../../assets/image/ic_lb_jt@3x.png">
              </div>
            </div>
            <div class="keySupervisionBottom">
              <div class="startTimeBox">{{emphasisData.time}}</div>
              <div class="startTimeBox">{{emphasisData.diffDay}}</div>
            </div>
        </div>
      </div>
    </div> -->
    <div class="centerBox">
        <div class="tabBox">
            <span class="item" :class="{item_active:isShowTab==0}" @click="isShowTab=0">规范指数</span>
            <span class="score">{{format.standardScore}}</span>
            <span class="item" :class="{item_active:isShowTab==1}" @click="isShowTab=1">品质指数</span>
            <span class="score">{{format.qualityScore}}</span>
            <span class="item" :class="{item_active:isShowTab==2}" @click="isShowTab=2">体验指数</span>
            <span class="score">{{format.experienceScore}}</span>
        </div>
        <div class="tabContent" v-if="isShowTab==0">
            <div class="scoring_index" :class="{line_bottom:!deductList.length}">
                <div class="scoring_index_score">{{format.standardScore}}<span class="unit">分</span></div>
                <div class="scoring_index_score_current">当前得分</div>
            </div>
             <div class="noData" :class="{hasDataBox:deductList.length>0, line_bottom:deductList.length}" >
                <div class="noData_score" v-if="deductList.length==0">该企业暂无扣分记录</div>
                <div class="addData"  >
                    <div class="addData_content_no" v-if="emphasisData.businessStatus === 11 || emphasisData.businessStatus === 12"><span>+</span>新增扣分</div>
                    <div class="addData_content" @click="goAddMark" v-else><span>+</span>新增扣分</div>
                </div>
            </div>
            <div>
                <div class="deductionRecord" v-if="deductList.length>0">
                    <div class="allRecord">共{{deductList.length}}条扣分记录</div>
                    <div class="effectieDuction">累计生效扣分: {{deductCount}}分</div>
                </div>
                <ul class="recordList">
                    <!--  :class="{line_bottom:index!=deductList.length-1,text_nomerColor:item.stateName=='已下线'}" -->
                    <li class="recordList_li"  :class="{text_nomerColor:item.stateName=='已下线'}" @click="goWorkNorm(item)" v-for="(item, index) in deductList" :key="index">
                        <div class="recordList_li_question">
                            <div class="recordList_li_left">
                              <span>{{item.detailName}}</span>
                              <span class="recordList_li_left_one" v-show='item.createTime'>{{item.createTime | filtTime}}</span>
                            </div>
                            <div class="recordList_li_right">
                               <div class="left_box">
                                  <span>-{{item.score}}分</span>
                                  <span class="status">{{item.stateName}}</span>
                               </div>
                               <img src="../../../../assets/image/ic_lb_jt@3x.png" alt="">
                            </div>
                        </div>
                        <div class="recordList_li_question">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tabContent" v-if="isShowTab==1">
            <div v-if="format.qualityScore === '' ||format.qualityScore === null||format.qualityScore==undefined" class="noAvailable">
                暂无结果
            </div>
            <div class="scoring_index" :class="{line_bottom:qualityList.length > 0}" v-else>
                <div class="scoring_index_score">{{format.qualityScore}}<span class="unit">分</span></div>
                <div class="scoring_index_score_current">当前得分</div>
            </div>
            <div class="deductionRecord" v-if="qualityList.length > 0">
                <div class="allRecord">共<span>{{qualityList.length}}</span>条评分记录</div>
            </div>
            <ul class="qualityIndex">
                <li class="qualityIndex_li" :class="{line_bottom:index!=qualityList.length-1}"  @click="goWorkOrder(item)" v-for="(item,index) in qualityList" :key="index">

                    <div class="qualityIndex_li_left">
                        <div class="getScore" v-if="item.score">得分值：{{item.score}}</div>
                        <div class="getScore" v-else>得分值：暂无</div>
                        <div class="qualityIndex_li_people" v-show='item.ratingTime'>评分时间：{{item.ratingTime|filtTime}}</div>
                        <div class="qualityIndex_li_people">评分专员：{{item.employeeName}}</div>
                        <div class="qualityIndex_li_people">工单状态：{{item.statusName}}</div>
                        <div class="qualityIndex_li_people">所属任务：{{item.taskName}}</div>
                    </div>
                    <div class="qualityIndex_li_right"><span>{{item.statusName}}</span><img src="../../../../assets/image/ic_lb_jt@3x.png" alt=""></div>
                </li>
            </ul>
        </div>
        <div class="tabContent" v-if="isShowTab==2">
            <div class="scoring_index">
                <div class="scoring_index_score">{{format.experienceScore}}<span class="unit">分</span> </div>
                <div class="scoring_index_score_current">满分10分</div>
            </div>
        </div>
    </div>
    <touristsEvaluation v-if="isShowTab==2"/>
    <transition name="fade">
        <div
          class="examineDetailTipsBox"
          transition="fade"
          v-show="examineDetailTips"
          @click="handleTest"
        >
          <img src="../../../../assets/image/icon_ts_tg.png" v-if="tipsIcon" />
          <img src="../../../../assets/image/icon_ts_gx.png" v-if="!tipsIcon" />
          <p>{{tipsMsg}}</p>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/integrity'
    import touristsEvaluation from './touristsEvaluation.vue'
    import moment from 'moment';

    export default {
        name: 'scoreDetails',
        components: {
            touristsEvaluation
        },
        data () {
            return {
                enterpriseId: '', // 企业ID
                active: '1',
                scoreFlag: false,
                isShow: true,
                isShowTab: 0,
                navList: ['规范指数', '品质指数', '体验指数'],
                format: {}, // 企业详情
                deductList: [], // 企业规范指数
                deductCount: 0, // 规范指数累计扣分
                emphasisData: {}, // 重点关注
                qualityList: [], // 品质指数
                numCount: '', // 的分值
                enterpriseGradeId: '', // 规范指数参数 企业评分ID
                supervisionId: '', // 重点关注与黑名单ID
                currentTime: '', // 品质得分
                // 提交按钮提交完的tip状态
                examineDetailTips: false,
                tipsIcon: true,
                tipsMsg: '',
                statusTypeName: '',
                scoreDetailsStatusToast: JSON.parse(sessionStorage.getItem('scoreDetails'))
            };
        },
        created () {
            if (this.$route.query.name === 'uploadData') {
                this.$Toast.success({
                    message: '退出成功',
                    forbidClick: true
                })
            }
            this.enterpriseId = this.$route.query.id || this.$route.params.id;
            this.isNeedTips();
            this.getEnterpriseDetail() // 企业详情
            this.getEnterpriseHisQualityNormalList() // 品质指数
            this.getSupervisionTaskInfo() //  重点关注 黑名单
        },
        methods: {
            // 取消缓存
            clearSaved () {
                if (localStorage.getItem('enterpriseGradeId')) {
                    localStorage.removeItem('enterpriseGradeId');
                }
            },
            // 点击取消弹窗
            handleTest () {
                this.examineDetailTips = false;
            },
            // 弹窗事件
            isShowTipsBox () {
                this.examineDetailTips = true
                let t = setTimeout(() => {
                    this.examineDetailTips = false;
                }, 2000)
            },
            // 判断是否需要弹窗
            isNeedTips () {
                if (this.scoreDetailsStatusToast && this.scoreDetailsStatusToast.fromPage === 'addMrks') {
                    this.tipsMsg = this.scoreDetailsStatusToast.message
                    this.isShowTipsBox();
                    sessionStorage.removeItem('scoreDetails')
                }
            },
            // 重点关注 黑名单
            getSupervisionTaskInfo () {
                api.supervisionTaskInfo({ enterpriseId: this.enterpriseId }).then(res => {
                    if (res.ret === 0) {
                        this.emphasisData = res.data
                        this.supervisionId = res.data.supervisionId
                        // 纳入时间
                        if (res.data.status === 20) {
                            this.statusTypeName = '监管详情'
                        } else if (res.data.status === 40) {
                            this.statusTypeName = '监管历史'
                        } else if (res.data.status === 50) {
                            this.statusTypeName = '监管记录'
                        }
                    }
                })
            },
            // 跳转规范指数
            goWorkNorm (e) {
                this.$router.push({
                    path: 'pointDetail',
                    query: {
                        id: e.id // 扣分详情ID
                        // enterpriseId: this.enterpriseId // 企业ID
                    }
                })
            },
            // 跳转监管明细
            goSupervisionDetails () {
                // 进入重点关注状态
                this.$router.push({
                    path: 'supervisionDetails',
                    query: {
                        supervisionId: this.supervisionId, // 重点关注与黑名单ID = 企业监管ID
                        enterpriseId: this.enterpriseId, // 企业ID
                        flag: 1

                    }
                })
            },
            // 品质指数 跳转到工单详情
            goWorkOrder (e) {
                this.$router.push({
                    path: 'workOrder',
                    query: {
                        enterpriseId: e.workOrderId,
                        currentTime: this.currentTime
                    }
                })
            },
            // 跳转企业详情
            goCompany () {
                this.$router.push({
                    path: 'enterpriseDetail',
                    query: {
                        enterpriseId: this.enterpriseId
                    }
                })
            },
            // 规范指数
            getDeductList () {
                api.deductList({ enterpriseGradeId: this.enterpriseGradeId }).then(res => {
                    if (res.ret === 0) {
                        this.deductList = res.data
                        let arr = this.deductList.filter(e => e.status === 0)
                        let num = 0
                        for (var i = 0; i < arr.length; i++) {
                            num += arr[i].score * 100
                        }
                        this.deductCount = num / 100
                    }
                })
            },
            // 品质指数
            getEnterpriseHisQualityNormalList () {
                api.enterpriseHisQualityNormalList({ enterpriseId: this.enterpriseId }).then(res => {
                    if (res.ret === 0) {
                        this.qualityList = res.data
                        let num = 0
                        for (var i = 0; i < this.qualityList.length; i++) {
                            num += this.qualityList[i].scoringMethod * 100
                        }
                        this.numCount = num / 100
                    }
                })
            },
            // 企业详情
            getEnterpriseDetail () {
                api.enterpriseDetail({ enterpriseId: this.enterpriseId }).then(res => {
                    if (res.ret === 0) {
                        let data = res.data
                        this.format = data
                        console.log(this.format, 'dataxs')
                        // this.$set(this.format,'qualityScore',null);
                        this.currentTime = res.data.qualityScore // 品质得分
                        this.enterpriseGradeId = res.data.enterpriseGradeId
                        this.getDeductList() // 规范指数
                    }
                })
            },
            // 新增扣分
            goAddMark () {
                this.$router.push({
                    path: 'addMarks',
                    query: {
                        data: this.format,
                        id: this.enterpriseId
                    }
                })
            }
        },
        // 时间搓
        filters: {
            filtTime (str) {
                var date = new Date(str);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
                let strDate = Y + M + D + h + m + s;
                return strDate;
            },
            filt (str) {
                // let wordValue = str.toString().substring(str.indexOf('：') + 1);
                let wordValue = moment(str).format('YYYY-MM-DD HH:MM:SS')
                return wordValue;
            },
            toFix (str) {
                if (str) {
                    return Number(str.toFixed(2))
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.wrap{
     width:100%;
    .top_title{
      width:100%;
      height:38px;
      background-color:rgba(54, 179, 116,0.2);
      opacity: 0.9;
      line-height: 38px;
      font-size:14px;
      color:#36B374;
      padding-left: 12px;
      box-sizing: border-box;
    }
    .box_wrap{
     padding:24px 12px 24px 12px;
     background:rgba(251,251,251,1);
     min-height: 100vh;
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-active {
      opacity: 0;
    }

    .examineDetailTipsBox {
      width: 120px;
      height: 124px;
      padding: 24px 0 0 0;
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.7);
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      > img {
        width: 50px;
        height: 50px;
        margin: 0 auto 12px;
        display: block;
      }

      > p {
        text-align: center;
        color: #fff;
      }
    }
    }
.scoreTop {
    overflow: hidden;
    // margin-bottom: 10px;

  .scoreTop_left {
    float: left;
    line-height: 24px;
    font-size: 14px;
    width: 226px;
    .hotel {
      line-height:24px;
      font-size:16px;
      width: 226px;
      font-weight:600;
      color:rgba(51,51,51,1);
      padding-right: 23px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .timeAdress {
      font-size:12px;
      font-weight:400;
      color:rgba(102,102,102,1)
    }
    .timeAdressItem{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .tag {
      overflow: hidden;
      .adre {
        margin: 4px;
        padding: 2px 4px 0px 4px;
        color: #2283e6;
        line-height: 18px;
        font-size: 12px;
        text-align: center;
        float: left;
        margin-left: -6px;
        transform: scale(0.85);
        border-radius: 1px;
      }
      .touri {
        margin: 4px;
        float: left;
        // border: 1px solid @base-color;
        color: @base-color;
        line-height: 18px;
        font-size: 12px;
        text-align: center;
        transform: scale(0.85);
        margin-left: -9px;
          padding: 2px 4px 0px 4px;
        border-radius: 1px;
      }
    }
    .more {
      font-size:12px;
      font-weight:400;
      color:rgba(54,179,116,1);
      span{
          margin-left: 4px;
      }
    }

  }
  .scoreTop_right {
    float: left;
    border-left: 1px solid #cccccc;
    color: #36B374;
    .score {
        font-size: 20px;
        font-weight:bold;
        padding-left: 42px;
        span{
          margin-left:4px;
          font-size:10px;
        }
    }
    .score_wu {
        font-size: 12px;
        font-weight:bold;
        padding-left: 42px;
        color: #666666;
        line-height: 18px;
    }
    .scoreNo {
      font-size: 12px;
      line-height: 22px;
       padding-left: 32px;
    }
  }
  .warm_text{
    color: #FF4D4D;
  }
}
.scoreChange{
  width:100%;
  .score1{
    font-size:16px;
    color:#333;
    font-weight: 700;
  }
  .score2{
    font-size:12px;
    color:#666666;
    margin-top:12px;
  }
  .schange{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top:8px;
    span:nth-child(1){
      font-size:12px;
      padding:3px 4px;
      background-color: #36B374;
      color:#fff;
      display: inline-block;
    }
    span:nth-child(2){
      font-size:12px;
      padding:2px 4px;
      color:#36B374;
      display: inline-block;
      border:1px solid #36B374;
    }
  }

}
.centerBox{
    background: #fff;
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin-top:24px;
    .tabBox {
      white-space: nowrap;
      height: 54px;
      display: flex;
      line-height: 46px;
      width: 100%;
      padding: 16px 15px 15px 16px;
      background:#fff!important;

      .item {
        display: inline-block;
        height: 22px;
        line-height: 22px;
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        margin-right: 4px;
      }
      .score{
        color: #999999;
        line-height: 22px;
        margin-right: 24px;
        font-size:12px;
        font-weight:400;
        color:rgba(153,153,153,1);

      }
      .item_active {
        border-bottom: 2px solid @base-color;
        color: @base-color;
        padding-bottom: 1px;
        font-weight: 500;
      }
    }

}
.tabContent{
overflow: hidden;

.noAvailable{
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
    margin-top: 40px;
    line-height: 20px;
}
}
.changeCom{
      margin-top:20px;
      padding:16px;
      box-sizing: border-box;
      width:100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .tip1{
        font-size:12px;
        padding:2px 4px;
        background-color: #36B374;
        color:#fff;
      }
      .tip2{
        width:64%;
        font-size:12px;
        color:#333;
      }
      .changeDetail{
        display: flex;
        flex-direction: row;
        align-items: center;
        .tip3{
          font-size:12px;
          color:#333;
        }
        img{
          width:12px;
          height:12px;
        }
      }
}
.brackBox {
  width:100%;
  height:100%;
  background:rgba(255,255,255,1);
  box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
  border-radius:3px;
  margin-bottom: 16px;
  margin-top:24px;
  .brackBox_header {
    width:351px;
    height:44px;
    background:rgba(255,232,209,1);
    border-radius:3px 3px 0px 0px;
    display:flex;
    justify-content: space-between;
    padding: 12px 16px;
    margin-top:16px;
    .header_left {
      display:flex;
      justify-content: center;
      align-items: center;
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(255,140,25,1);
      line-height:14px;
      img {
        width:20px;
        height:20px;
        margin-right: 12px;
      }
    }
    .header_right{
      display:flex;
      justify-content: center;
      align-items: center;
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:12px;
      div:nth-child(1) {
        margin-right: 4px;
      }
    }
  }
  .brackBox_header_wrap {
    width:351px;
    height:44px;
    background:#FFDBDB;
    border-radius:3px 3px 0px 0px;
    display:flex;
    justify-content: space-between;
    padding: 12px 16px;
    .header_left {
      display:flex;
      justify-content: center;
      align-items: center;
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:#FF4D4D;
      line-height:14px;
      img {
        width:20px;
        height:20px;
        margin-right: 12px;
      }
    }
    .header_right{
      display:flex;
      justify-content: center;
      align-items: center;
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:12px;
      div:nth-child(1) {
        margin-right: 4px;
      }
    }
  }
  .center {
    padding: 12px 16px 16px;
    .score_title {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        .left {
          font-size:14px;
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight:600;
          color:rgba(51,51,51,1);
          line-height:14px;
        }
        .right {
            font-size:20px;
            font-family:DIN-Bold,DIN;
            font-weight:bold;
            color:rgba(255,140,25,1);
            line-height:20px;
            margin-left: 8px;
        }
    }
    .score_count {
        display: flex;
        .count_box {
            margin-right: 24px;
            width: 85px;
            .count_box_left {
              font-size: 12px;
              color: #999999;
            }
            .count_box_right {
              font-size: 12px;
              color: #333333;
            }
        }
        div:last-child {
            margin-right: 0px;
            width: 85px;
            .count_box_left {
              font-size: 12px;
              color: #999999;
            }
            .count_box_right {
              font-size: 12px;
              color: #333333;
            }
        }
    }
  }

  .brackBox_time {
    padding: 16px;
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:12px;
    .time_top {
      margin-bottom: 8px;
    }
    .brackType {
      width: 86px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      color: #fff;
      background: #008CFD;
      border-radius: 14px;
      font-size: 10px;
      margin-top: 12px;
    }
  }
}
.brackBoxEdit {
  width:100%;
  margin-bottom: 16px;
  margin-top:24px;
  height:46px;
  background:rgba(255,255,255,1);
  box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
  border-radius:3px;
  .brackBox_header {
    width:351px;
    height:44px;
    border-radius:3px 3px 0px 0px;
    display:flex;
    justify-content: space-between;
    padding: 12px 16px;
    margin-top:16px;
    .header_left {
      display:flex;
      justify-content: center;
      align-items: center;
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:#2283E6;
      line-height:14px;
    }
    .header_right{
      display:flex;
      justify-content: center;
      align-items: center;
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:12px;
      div:nth-child(1) {
        margin-right: 4px;
      }
    }
  }
}
// .keySupervisionBox{
//   padding-bottom: 30px;
//   background-color: #FBFBFB;
//   box-shadow:0px 0px -2px 0px rgba(0,0,0,0.04);
//   border-radius:3px;
//   .keySupervisionContent{
//     background:rgba(255,255,255,1);
//     box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
//     border-radius:3px;
//     min-height: 94px;
//     margin: 0 auto;
//     background-color: #fff;
//     display: flex;
//     align-items: center;
//     padding: 16px;
//     justify-content: space-between;
//     width: 100%;
//     img{
//       width: 60px;
//       height: 60px;
//     }
//     .left_box{
//       display: flex;
//       flex-direction: column;
//       margin-left: 12px;
//       width: 100%;

//         .keySupervisionTop{
//           width: 100%;
//           margin-top: 16px;
//           display: flex;
//           justify-content: space-between;
//           margin-bottom: 8px;
//           .stateTitle{
//             margin-right: 12px;
//             font-weight: bold;
//             font-size:14px;
//             font-weight:600;
//             color:rgba(255,140,25,1);
//           }
//           .stateBage{
//             font-size: 12px;
//             text-align: center;
//             color: #fff;
//             background-color: @base-color;
//           }
//           .toDetail{
//             font-size:12px;
//             font-weight:400;
//             color:rgba(51,51,51,1);
//             display: flex;
//               img{
//                 width: 12px;
//                 height: 12px;
//                 margin-left: 4px;
//               }
//             }
//          }
//         .keySupervisionBottom{
//           .startTimeBox{
//             height: 20px;
//             line-height: 20px;
//             font-size:12px;
//             font-weight:400;
//             white-space:nowrap;
//             color:rgba(102,102,102,1);
//           }
//         }
//     }

//   }
// }

.title_left {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    span{
        color: red;
        margin-bottom: 8px;
        font-size: 8px;
    }
}
.scoring_index {
  margin-top: 14px;
  background: #fff;
  padding-bottom: 10px;
    .scoring_index_score {
        width: 100%;
        line-height: 22px;
        text-align: center;
        font-size:20px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:20px;
        .unit{
          font-size:10px;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:10px;
          margin-left: 4px;
        }
  }
  .scoring_index_score_current {
    margin-top: 8px;
    text-align: center;
    font-size:12px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:12px;
  }
}
.noData {
  overflow: hidden;
  height: 266px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .noData_score {
    line-height: 14px;
    color: #999;
    font-size: 12px;;
    text-align: center;
    margin-bottom: 16px
  }
  .addData {
        font-size: 12px;
        text-align: center;
        padding-bottom: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .addData_content {
            width: 80px;
            height: 24px;
            line-height: 24px;
            background-color:  @base-color;
            color: #fff;
            span{
                margin-right: 4px;
            }
        }
        .addData_content_no {
            width: 80px;
            height: 24px;
            line-height: 24px;
            background-color: #99D9BB;
            color: #fff;
            span{
                margin-right: 4px;
            }
        }
  }
}
.hasDataBox{
  height: 40px;
}
.deductionRecord {
  padding: 16px 16px 0 ;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .allRecord {
    font-weight:400;
    color:rgba(153,153,153,1);
    margin-bottom: -4px;
    span{
      margin: 0 4px;
    }
  }
  .effectieDuction {
    float: right;
    font-size:12px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:12px;
  }
}

.qualityIndex {

  .qualityIndex_li {
    line-height: 22px;
    font-size: 12px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    .qualityIndex_li_left {
      font-size:12px;
      font-weight:400;
      color:rgba(102,102,102,1);
      .getScore {
          font-size:14px;
          font-weight:600;
          color:rgba(51,51,51,1);
          margin-bottom: 2px;
      }
      .qualityIndex_li_people {
        font-size: 12px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        max-width: 220px;
      }
    }
    .qualityIndex_li_right {
      width: 90px;
      font-size:14px;
      font-weight:400;
      color:rgba(153,153,153,1);
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      img{
        width: 12px;
      }
      span{
          margin-right: 8px;
      }
    }
  }
}
.recordList {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  .text_nomerColor{
      span{
        color: #999999!important;
      }
    }
  .recordList_li {
    padding-top: 10px;
    // padding-bottom: 10px;

    .recordList_li_question {
      overflow: hidden;
      .recordList_li_left {
        display: flex;
        flex-direction: column;
        float: left;
        max-width: 240px;
        white-space: nowrap;
        font-size:14px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:16px;
        span{
            text-overflow:ellipsis;
            overflow: hidden;
        }
        .recordList_li_left_one {
            margin-top: 8px;
            float: left;
            font-weight:400;
            color:rgba(102,102,102,1);
            font-size: 12px;
            height: 13px;
        }
      }
      .recordList_li_right {
            margin-top: -1px;
            float: right;
            font-size: 12px;
            line-height: 20px;
            display: flex;
            align-items: center;
        .left_box{
            display: flex;
            flex-direction: column;
            margin-right: 4px;
         span{
              font-size:16px;
              font-weight:400;
              color:rgba(51,51,51,1);
              margin-bottom: 5px;
            }
          .status{
                transform-origin: left top;
                -webkit-transform: scale(0.5);
                transform: scale(0.85);
                color: #36B374;
                font-size:12px;
                font-weight:400;
                margin-left: 4px;
            }
        }
        img{
          width: 12px;
        }

      }
    }

  }
}
.experienceBox{
    text-align: center;
    margin-top: 30px;
    padding-bottom: 10px;
    .experience {
        margin-bottom: 10px;
        span{
            font-size: 18px;
            font-weight: bold;
        }
    }
}
}
</style>
<style lang="less">
.van-tabs__line {
  background-color: #36b374 !important;

}
</style>
